import React from 'react'
import SearchBar from './SearchBar'
import FeatureButtons from './FeatureButtons'
import PartnerLinks from './PartnerLinks'

export default function VietradeBody() {
  return (
    <div className='flex-1 container mx-auto px-4 py-4 overflow-y-auto'>
        <SearchBar/>
        <FeatureButtons/>
        <PartnerLinks/>
    </div>
  )
}
